import styled from 'styled-components';
import FormControlLabel from '@mui/material/FormControlLabel';

import colors from '../../../../../styles/colors';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`;

const AgreementRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  column-gap: 4px;
`;

const StyledFormControlLabel = styled(FormControlLabel)`
  margin-right: 0;

  .MuiFormControlLabel-label {
    font-size: 14px;
    color: ${({ $isDarkTheme }) => ($isDarkTheme ? colors.base.alpha : colors.base.beta)};
  }
`;

const ReadTermsButton = styled.button`
  min-height: 44px;
  padding: 0 4px;
  border: none;
  background: none;
  font-size: 14px;
  font-weight: 600;
  text-decoration: underline;
  cursor: pointer;
  color: ${({ $isDarkTheme }) => ($isDarkTheme ? colors.base.primary : colors.base.secondary)};
`;

const ErrorText = styled.span`
  font-size: 12px;
  color: ${colors.base.danger};
`;

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
  max-width: 560px;
  background-color: ${({ $isDarkTheme }) => ($isDarkTheme ? colors.shades.dark1 : colors.base.alpha)};
`;

const ModalTitle = styled.h2`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: ${({ $isDarkTheme }) => ($isDarkTheme ? colors.base.alpha : colors.base.beta)};
`;

const TermsScroll = styled.div`
  max-height: 55vh;
  overflow-y: auto;
`;

export {
  Container,
  AgreementRow,
  StyledFormControlLabel,
  ReadTermsButton,
  ErrorText,
  ModalContent,
  ModalTitle,
  TermsScroll,
};
